<template>
    <div class="jgile-carousel">
        <slot
            :next="next"
            :previous="previous"
            :go-to="goTo"
            :current-item="currentItem"
            :item-count="itemCount"
            :current-count="currentCount"
            :items="items"
        ></slot>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
        value: {
            required: false,
        },
    },
    data: () => ({
        visibleItem: 0,
    }),
    computed: {
        currentItem() {
            return _.get(this.items, this.visibleItem);
        },
        currentCount() {
            return this.visibleItem + 1;
        },
        itemCount() {
            return _.castArray(this.items).length;
        },
    },
    methods: {
        previous() {
            if (this.visibleItem === 0) {
                this.visibleItem = this.items.length - 1;
            } else {
                this.visibleItem--;
            }

            this.select();
        },
        next() {
            if (this.visibleItem === this.items.length - 1) {
                this.visibleItem = 0;
            } else {
                this.visibleItem++;
            }

            this.select();
        },
        goTo(index) {
            if (this.items.length >= index) {
                this.visibleItem = index;
            } else {
                this.visibleItem = 0;
            }

            this.select();
        },
        select() {
            this.$emit('input', this.currentItem);
        },
    },
    watch: {
        items: {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (newVal.length <= this.visibleItem) {
                    this.visibleItem = 0;
                }

                this.select();
            },
        },
    },
};
</script>
